import { render, staticRenderFns } from "./ProductBadgeLabelEditForm.vue?vue&type=template&id=537a4582&scoped=true&"
import script from "./ProductBadgeLabelEditForm.vue?vue&type=script&lang=js&"
export * from "./ProductBadgeLabelEditForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductBadgeLabelEditForm.vue?vue&type=style&index=0&id=537a4582&lang=scss&scoped=true&"
import style1 from "./ProductBadgeLabelEditForm.vue?vue&type=style&index=1&id=537a4582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a4582",
  null
  
)

export default component.exports